import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import MaterialSelector from '../MaterialSelector'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView05ImageOptions } from './views/InteriorView05'

class X46MK2Galley extends Component {
  constructor (props) {
    super(props)
    this.handleGalleyChange = this.handleGalleyChange.bind(this)
  }

  handleGalleyChange (newValue) {
    let configuration = this.props.configuration
    configuration.Worktop = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = interiorView05ImageOptions

    let image = (
      <X46MK2InteriorConfiguratorImage
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='GALLEY' />
          </h1>

          <MaterialSelector
            label={this.props.configuration.Worktop.label}
            options={this.props.worktopOptions}
            value={this.props.configuration.Worktop}
            onChange={this.handleGalleyChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Galley)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Galley.js